/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container, Row,
} from 'reactstrap';
import { message } from 'antd';
import { LOCALSTORAGE_TOKEN } from '../../../../utils/Types';
import CourseListTable from './components/CourseList';
import ListData from './components/ListData';
import { URL_COURSE } from '../../../../utils/EndPoints';

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const listDataTable = ListData(courses);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
    };
    axios.get(URL_COURSE, options)
      .then((res) => {
        setCourses(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        message.error('Something went wrong!');
      });
  }, []);

  return (
    <Container className="dashboard">
      <Row>
        <CourseListTable
          listDataTable={listDataTable}
          isLoading={isLoading}
        />
      </Row>
    </Container>
  );
};
export default CourseList;
